import React, { useState } from "react";
// Icon SVGs for footer social/contact links
const icons = {
  whatsapp: (
    <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" className="inline align-middle"><path d="M12.004 2.003a9.927 9.927 0 0 0-8.09 15.857l-1.36 4.01a1 1 0 0 0 1.263 1.263l4.01-1.36A9.997 9.997 0 1 0 12.004 2.003zm0 2a8 8 0 1 1 0 16 7.96 7.96 0 0 1-4.09-1.16l-.29-.17-2.38.81.81-2.38-.17-.29A7.96 7.96 0 0 1 4.004 12c0-4.42 3.58-8 8-8zm-3.13 4.25c-.19-.42-.39-.43-.57-.44-.15-.01-.33-.01-.51-.01s-.47.07-.72.35c-.25.28-.97.95-.97 2.32 0 1.37.99 2.7 1.13 2.89.14.19 1.91 3.05 4.7 4.16.66.28 1.18.45 1.58.57.66.21 1.26.18 1.73.11.53-.08 1.63-.67 1.86-1.32.23-.65.23-1.2.16-1.32-.07-.12-.26-.19-.54-.33-.28-.14-1.63-.8-1.88-.89-.25-.09-.43-.13-.61.13-.18.26-.7.89-.86 1.07-.16.18-.32.2-.6.07-.28-.13-1.18-.43-2.25-1.37-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5z" /></svg>
  ),
  instagram: (
    <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" className="inline align-middle"><path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5zm4.25 2.25a6.25 6.25 0 1 1 0 12.5 6.25 6.25 0 0 1 0-12.5zm0 1.5a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5zm6.13 1.12a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0z" /></svg>
  ),
  x: (
    <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" className="inline align-middle"><path d="M17.53 3.5h3.22l-7.04 8.06 8.3 9.94h-6.54l-5.13-6.13-5.87 6.13H2.25l7.5-8.32L1.5 3.5h6.7l4.67 5.6 4.66-5.6zm-1.13 15.13h1.78l-5.44-6.51-6.13 6.51h1.97l4.16-4.41 3.66 4.41zm-8.47-13.1l5.13 6.13 5.87-6.13h-1.97l-4.16 4.41-3.66-4.41h-1.21z" /></svg>
  ),
  tokopedia: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 512 512"
      fill="none"
      className="inline align-middle text-gray-400 group-hover:text-green-600 transition-colors duration-200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect width="512" height="512" rx="120" fill="currentColor" />
        <ellipse cx="256" cy="320" rx="120" ry="80" fill="#A5D6A7" />
        <ellipse cx="170" cy="240" rx="70" ry="70" fill="#fff" />
        <ellipse cx="342" cy="240" rx="70" ry="70" fill="#fff" />
        <ellipse cx="170" cy="250" rx="50" ry="50" fill="#333" />
        <ellipse cx="342" cy="250" rx="50" ry="50" fill="#333" />
        <ellipse cx="185" cy="235" rx="15" ry="15" fill="#fff" />
        <ellipse cx="357" cy="235" rx="15" ry="15" fill="#fff" />
        <ellipse cx="256" cy="340" rx="40" ry="30" fill="#FFD600" />
        <path d="M256 370c-20 0-40-20-40-30 0 0 20 10 40 10s40-10 40-10c0 10-20 30-40 30z" fill="#FF9800" />
        <path d="M180 120c0-50 152-50 152 0" stroke="#333" strokeWidth="20" strokeLinecap="round" />
      </g>
    </svg>
  ),
};
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header, ProductGrid, ProductModal } from "./components";
import InfoPage from "./info";

// Mock data for products with multiple images for slideshow
const products = [
  {
    id: 1,
    title: "Dune Arakkis Shai Hulud Arabic",
    images: [
      "https://images.tokopedia.net/img/cache/500-square/VqbcmM/2025/2/10/d6b30b33-e2db-4565-92ec-b6997744b656.png.webp?ect=4g",
      "https://images.tokopedia.net/img/cache/500-square/VqbcmM/2025/2/10/84ef6335-8da4-4aa7-ae25-afcc3ff3c168.png.webp?ect=4g"
    ],
    category: "Archive",
    description: "A contemplative piece exploring the intersection of thought and space."
  },
  {
    id: 2,
    title: "Perfect Days - Soundtrack & Komorebi",
    images: [
      "https://images.tokopedia.net/img/cache/500-square/VqbcmM/2025/2/3/9a777e89-be4e-4163-aea1-86313b7ea830.png.webp?ect=4g",
      "https://images.tokopedia.net/img/cache/500-square/VqbcmM/2025/2/3/3868b208-0f30-461d-8515-0c33079ce1ed.png.webp?ect=4g",
      "https://images.tokopedia.net/img/cache/500-square/VqbcmM/2025/2/3/914f7d39-8d47-4c09-8368-4f8d9af052fc.png.webp?ect=4g",
      "https://images.tokopedia.net/img/cache/500-square/VqbcmM/2025/2/3/f142b0e8-882d-4681-9fe2-254f85f56fd9.png.webp?ect=4g",
    ],
    category: "Archive",
    description: "Collaborative design exploring contemporary streetwear aesthetics."
  },
  {
    id: 3,
    title: "Architecture Student - Stress Level Midnight",
    images: [
      "images/arch_student_1.jpg",
      "images/arch_student_2.jpg"
    ],
    category: "Archive",
    description: "A narrative journey through architectural and emotional spaces."
  },
  {
    id: 4,
    title: "Perpanjangan dalam Jaringan",
    images: [
      "images/pdj_1.jpg",
      "images/pdj_2.jpg",
      "images/pdj_3.jpg",
      "images/pdj_4.jpg",
    ],
    category: "Archive",
    description: "Digital culture meets physical form in this interactive design."
  },
  {
    id: 5,
    title: "This Year is Going To Be My Year",
    images: [
      "images/tyigtbmy_1.jpg",
      "images/tyigtbmy_2.jpg",
      "images/tyigtbmy_3.jpg",
      "images/tyigtbmy_4.jpg",
      "images/tyigtbmy_5.jpg",
      "images/tyigtbmy_6.jpg",
      "images/tyigtbmy_7.jpg",
      "images/tyigtbmy_8.jpg",
    ],
    category: "Archive",
    description: "Exploring the pathway from creative spark to revolutionary design."
  }
];

function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartItems, setCartItems] = useState(0);

  const openModal = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  const addToCart = () => {
    setCartItems(cartItems + 1);
    closeModal();
  };

  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Routes>
          {/* <Route path="/info" element={
            <>
              <Header cartItems={cartItems} />
              <InfoPage />
            </>
          } /> */}
          <Route path="/" element={
            <>
              <Header cartItems={cartItems} />
              <ProductGrid products={products} onProductClick={openModal} />
              {selectedProduct && (
                <ProductModal 
                  product={selectedProduct} 
                  onClose={closeModal}
                  onAddToCart={addToCart}
                />
              )}
            </>
          } />
        </Routes>
      </BrowserRouter>
      {/* Divider */}
      <div className="flex justify-center mt-8">
        <hr className="w-3/4 border-t border-gray-200 opacity-50" />
      </div>
      {/* Footer */}
      <footer className="py-6 text-center text-gray-500 text-sm bg-transparent">
        <div className="flex flex-col items-center gap-2">
          <div className="flex gap-4 mb-1">
            <a href="https://wa.me/6285117133562" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="hover:text-green-500 transition-colors">{icons.whatsapp}</a>
            <a href="https://instagram.com/forcinganidea" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-pink-500 transition-colors">{icons.instagram}</a>
            <a href="https://x.com/forcinganidea" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="hover:text-blue-400 transition-colors">{icons.x}</a>
            <a href="https://www.tokopedia.com/forcinganidea" target="_blank" rel="noopener noreferrer" aria-label="Tokopedia" className="group hover:text-green-600 transition-colors">{icons.tokopedia}</a>
            <a href="mailto:forcinganidea@gmail.com" target="_blank" rel="noopener noreferrer" aria-label="Email" className="hover:text-red-500 transition-colors">{icons.email}</a>
          </div>
          <div className="text-xs text-gray-400">&copy; 2025 Forcing an Idea</div>
        </div>
      </footer>
    </div>
  );
}

export default App;